export const MOTIVATION_ASSESSING = 'assessing';
export const MOTIVATION_BOOKMARKING = 'bookmarking';
export const MOTIVATION_CLASSIFYING = 'classifying';
export const MOTIVATION_COMMENTING = 'commenting';
export const MOTIVATION_DESCRIBING = 'describing';
export const MOTIVATION_EDITING = 'editing';
export const MOTIVATION_HIGHLIGHTING = 'highlighting';
export const MOTIVATION_IDENTIFYING = 'identifying';
export const MOTIVATION_LINKING = 'linking';
export const MOTIVATION_MODERATING = 'moderating';
export const MOTIVATION_QUESTIONING = 'questioning';
export const MOTIVATION_REPLYING = 'replying';
export const MOTIVATION_TAGGING = 'tagging';

export const ALL_MOTIVATIONS = [
  MOTIVATION_ASSESSING,
  MOTIVATION_BOOKMARKING,
  MOTIVATION_CLASSIFYING,
  MOTIVATION_COMMENTING,
  MOTIVATION_DESCRIBING,
  MOTIVATION_EDITING,
  MOTIVATION_IDENTIFYING,
  MOTIVATION_HIGHLIGHTING,
  MOTIVATION_LINKING,
  MOTIVATION_MODERATING,
  MOTIVATION_QUESTIONING,
  MOTIVATION_REPLYING,
  MOTIVATION_TAGGING,
];
